export default __webpack_public_path__ + "static/media/SecludedCoveMap.193eef68.jpg";